import MapCollection from "collections/map";
import Vue from "vue";
import rolesService from "@/Services/RolesService";
import $handleError from "@/plugins/handleError";

const state = () => ({
  roles: [],
  carregandoRoles: false,
  rolesLoaded: false,
  rolesList: [],
  outrosRolesList: [],
});
const mutations = {
  setRoles(state, roles) {
    const rolesMap = new MapCollection();
    roles.map((role) => rolesMap.set(role.id, role));
    Vue.set(state, "roles", rolesMap);
    Vue.set(state, "rolesLoaded", true);
    Vue.set(state, "rolesList", Array.from(state.roles.values()));
    Vue.set(state, "outrosRolesList", state.rolesList);
  },
  setCarregandoRoles(state, newValue) {
    state.carregandoRoles = newValue;
  },
  adicionarRole(state, role) {
    state.roles.set(role.id, role);
    Vue.set(state, "rolesList", Array.from(state.roles.values()));
    Vue.set(state, "roles", state.roles);
  },
  atualizarRole(state, role) {
    state.roles.set(role.id, role);
    Vue.set(state, "rolesList", Array.from(state.roles.values()));
    Vue.set(state, "roles", state.roles);
  },
  deletarRole(state, roleId) {
    state.roles.delete(roleId);
    Vue.set(state, "rolesList", Array.from(state.roles.values()));
    Vue.set(state, "roles", state.roles);
  },
};
const actions = {
  async loadRoles({ commit }, options = {}) {
    commit("setCarregandoRoles", true);
    try {
      const rolesList = await rolesService.syncAll(options.force);
      commit("setRoles", rolesList);
    } catch (error) {
      $handleError(error);
    }
    commit("setCarregandoRoles", false);
  },
};
const getters = {
  roles: (state) => state.roles,
  carregandoRoles: (state) => state.carregandoRoles,
  rolesLoaded: (state) => state.rolesLoaded,
  rolesList: (state) => state.rolesList,
  outrosRolesList: (state) => state.outrosRolesList,
};
const namespaced = true;
export default {
  state,
  mutations,
  actions,
  getters,
  namespaced,
};
